import { render, staticRenderFns } from "./GoModules.vue?vue&type=template&id=187a7a02&"
import script from "./GoModules.vue?vue&type=script&lang=js&"
export * from "./GoModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports